import { chain, find, split } from 'lodash'
import {
  ICondicionBusqueda,
  IFiltrosBusquedaCV,
  IItemMenu,
  IModelDocReq,
  IOpcionCurr,
  IPregBusqueda,
  ITipoCondicionBusqueda,
} from 'src/model/candidato-api'

export class BusquedaCV {
  opt: IOpcionCurr
  pregslist: IPregBusqueda[]

  condiciones: Condicion[] = []
  vacio: boolean = true

  estado: boolean = false // activo búsqueda por estado
  fechas: boolean = false // activo búsqueda por fechas

  menu: IItemMenu | null
  idform: number

  maxcondiciones = -1

  generaFiltros(): IFiltrosBusquedaCV {
    return {
      idform: this.opt.item.idf,
      w: this._generaWhere(),
    } as IFiltrosBusquedaCV
  }

  private _generaWhere() {
    return chain(this.condiciones)
      .filter((c) => c.valido())
      .map((c) => c.generaWhere())
      .value()
  }

  setMaxCondiciones(max: number) {
    this.maxcondiciones = max
  }

  nuevaCondicionPregunta() {
    var c = new Condicion('PREGUNTA', this)

    this.condiciones.push(c)
    this.vacio = false

    return c
  }

  nuevaCondicionEstado() {
    this.condiciones.push(new Condicion('ESTADO', this))
  }

  nuevaCondicionFechas() {
    this.condiciones.push(new Condicion('FECHAS', this))
  }

  resetCondiciones() {
    this.condiciones = []
  }

  selMenu(menu: IItemMenu) {
    this.menu = menu
    this.idform = menu.idf

    this.vacio = !this.menu
  }

  selFormId(idform: number) {
    this.idform = idform
    this.menu = null

    this.vacio = !idform
  }

  quitarCondicion(idx: number) {
    this.condiciones.splice(idx, 1)
  }
}

export class Condicion {
  pregform: IPregBusqueda

  model1: any
  model2: any

  sel: string[] = [] // selecciones

  constructor(
    public tipo: ITipoCondicionBusqueda,
    private busqueda: BusquedaCV
  ) {}

  generaWhere(): ICondicionBusqueda {
    let where: ICondicionBusqueda = {
      tipocondicion: this.tipo,
      idq: null,
      cond_bool: null,
      cond_fin: null,
      cond_ini: null,
      cond_max: null,
      cond_min: null,
      cond_opt: null,
      cond_txt: null,
      incluir: true,
      cv_estado: null,
      cv_ini: null,
      cv_fin: null,
    }

    switch (this.tipo) {
      case 'PREGUNTA':
        this.completaWherePreg(where)
        break

      case 'FECHAS':
        this.completaWhereFechas(where)
        break

      case 'ESTADO':
        this.completaWhereEstado(where)
        break
    }

    return where
  }

  private completaWhereFechas(where: ICondicionBusqueda) {
    where.cv_ini = this.model1 && new Date(this.model1 as string)
    where.cv_fin = this.model2 && new Date(this.model2 as string)
  }

  private completaWhereEstado(where: ICondicionBusqueda) {
    where.cv_estado = this.model1 as string
  }

  private completaWherePreg(where: ICondicionBusqueda) {
    where.idq = this.pregform.q.idquest

    switch (this.pregform.t) {
      case 'SINO':
        where.cond_bool = this.model1 as boolean
        break

      case 'TXT':
        where.cond_txt = this.model1 as string
        break

      case 'SEL':
        where.cond_opt = chain(this.sel)
          .filter((s) => !!s)
          .value() // no considerar las null
        break

      case 'RANGO':
        where.cond_min = this.model1 as number
        where.cond_max = this.model2 as number
        break

      case 'PERIODO':
        where.cond_ini = this.model1 && new Date(this.model1 as string)
        where.cond_fin = this.model2 && new Date(this.model2 as string)
        break

      default:
    }
  }

  private seleccionaPreg(idq: number) {
    // buscar la pregunta en la lista
    if (this.busqueda.pregslist) {
      let find_ = find(this.busqueda.pregslist, (p) => p.q.idquest === idq)

      if (find_) this.pregform = find_
    }
  }

  filterReqDocToWhere(rule: IModelDocReq) {
    // solo soporte preguntas
    if (this.tipo !== 'PREGUNTA') return

    if (!rule.idquestion) return

    this.seleccionaPreg(rule.idquestion)

    switch (this.pregform.t) {
      case 'SINO':
        this.model1 = rule.cond_bool
        break

      case 'TXT':
        this.model1 = rule.cond_txt
        break

      case 'SEL':
        this.sel = split(rule.cond_opt, ';').filter((s) => !!s)
        break

      case 'RANGO':
        this.model1 = rule.cond_min
        this.model2 = rule.cond_max
        break

      case 'PERIODO':
        this.model1 = rule.cond_ini
        this.model2 = rule.cond_fin
        break

      default:
    }
  }

  condicionToFilterReqDoc(rule: IModelDocReq) {
    // solo soporte preguntas
    if (this.tipo !== 'PREGUNTA') return

    if (!this.pregform) return

    rule.idquestion = this.pregform.q.idquest

    rule.cond_bool = null
    rule.cond_txt = null
    rule.cond_opt = null
    rule.cond_min = null
    rule.cond_max = null
    rule.cond_ini = null
    rule.cond_fin = null

    switch (this.pregform.t) {
      case 'SINO':
        rule.cond_bool = this.model1 as boolean
        break

      case 'TXT':
        rule.cond_txt = this.model1 as string
        break

      case 'SEL':
        rule.cond_opt = chain(this.sel)
          .filter((s) => !!s)
          .join(';')
          .value() // no considerar las null
        break

      case 'RANGO':
        rule.cond_min = this.model1 as number
        rule.cond_max = this.model2 as number
        break

      case 'PERIODO':
        rule.cond_ini = this.model1 && new Date(this.model1 as string)
        rule.cond_fin = this.model2 && new Date(this.model2 as string)
        break

      default:
    }
  }

  valido() {
    switch (this.tipo) {
      case 'PREGUNTA':
        return !!this.pregform

      case 'FECHAS':
      case 'ESTADO':
        return true
    }
  }
}
